import request from '../untils/request';

export const tradingReturnConfirmManyApi = params => {
  return request({
    url: '/order/order-return/confirm-many',
    authCode: 'ORDER-RETURN_EDIT',
    params,
  });
};

export const tradingReturnConfirmCountApi = params => {
  return request({
    url: '/order/order-return/confirm-count',
    authCode: 'ORDER-RETURN_EDIT',
    params,
  });
};

export const tradingOrderSensitiveDataApi = params => {
  return request({
    url: '/order/order/sensitive-data',
    params,
  });
};